(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bamboo-capping-add-on"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var addOn = document.getElementById('BambooCappingAddOn');
    if (!addOn || window.sessionStorage.getItem('bamboo-capping-add-on-dismissed') === 'true') return;

    addOn.querySelector('.bamboo-capping-add-on__dismiss').addEventListener('click', function () {
      window.sessionStorage.setItem('bamboo-capping-add-on-dismissed', 'true');
      addOn.remove();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["panel-quantity-calculator"] && !Shopify.designMode) return;
  try {
    function initPanelCalculators() {
    document.querySelectorAll('[data-panel-calculator]').forEach(function (form) {
      if (form.dataset.panelCalculatorReady === 'true') return;
      form.dataset.panelCalculatorReady = 'true';
      var widthInput = form.querySelector('[name="panel-width"]');
      var sizeField = form.querySelector('[data-bamboo-size]');
      var sizeSelect = form.querySelector('[name="bamboo-size"]');
      var wpcNote = form.querySelector('[data-wpc-note]');
      var result = form.querySelector('[data-panel-result]');

      function selectedType() {
        return form.querySelector('input[name^="panel-type-"]:checked').value;
      }

      function updateMode() {
        var bamboo = selectedType() === 'bamboo';
        sizeField.hidden = !bamboo;
        wpcNote.hidden = bamboo;
      }

      form.querySelectorAll('input[name^="panel-type-"]').forEach(function (radio) {
        radio.addEventListener('change', updateMode);
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var width = Number(widthInput.value);
        if (!Number.isFinite(width) || width <= 0) {
          result.textContent = 'Enter a finished width greater than zero metres.';
          widthInput.focus();
          return;
        }

        var bamboo = selectedType() === 'bamboo';
        var coverage = bamboo ? Number(sizeSelect.value) : 0.2;
        var panels = Math.ceil(width / coverage);

        var output = '<p><strong>You need ' + panels + ' whole ' + (panels === 1 ? 'panel' : 'panels') + '.</strong></p>';
        output += '<p>Coverage used: ' + coverage.toFixed(1) + ' m per panel.</p>';

        if (bamboo) {
          var capping = Math.ceil(width / 2);
          output += '<p>Matching bamboo capping: <strong>' + capping + ' ' + (capping === 1 ? 'length' : 'lengths') + '</strong> (one 2 m length per two metres, rounded up).</p>';
        } else {
          output += '<p>Trim/capping is not calculated for WPC because no verified product rule is available.</p>';
        }

        result.innerHTML = output;
      });

      updateMode();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPanelCalculators, { once: true });
  } else {
    initPanelCalculators();
  }
  } catch(e) { console.error(e); }
})();

})();
